export default __webpack_public_path__ + "static/mid3a-cb494ff42ace252cc3063e521e4a5299.png";